var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-95"},[_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.submit.apply(null, arguments)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }